
import { Component, Vue } from "vue-property-decorator";
import NavBar from "./Config/header.vue";
import Choice from "./Config/choice.vue";
import Dropdown from "./Config/dropdown.vue";
import Content from "./Config/content.vue";
import { commodityConfig, commodityList } from "@/req/homeIndex";
@Component({
  components: {
    NavBar,
    Choice,
    Dropdown,
    Content,
  },
})
export default class Logout extends Vue {
  public isLoading = false;
  public finished = false;
  public loading = false;
  public status = false;
  public finishedText = "";
  public serverData: any = {};
  public screenData = {};
  public obj: any = {};
  public size = 10;
  public page = 1;
  public data: any = [];
  public orderData = {
    role_config_id: "-1",
    coin_config_id: "-1",
    order_time: "",
    order_price: "",
  };
  public onRefresh() {
    this.data = [];
    this.page = 1;
    this.status = false;
    this.loading = false;
    this.finished = false;
    this.listChange();
  }
  public created() {
    const obj: any = this.$route.query.obj;
    this.obj = JSON.parse(obj);
    this.configChange();
    this.getList();
  }
  public async configChange() {
    const res = await commodityConfig({
      box_game_id: this.obj.box_game_id,
    });
    if (res.code === 200) {
      this.screenData = res.data;
    }
  }
  public getList() {
    if (
      this.$route.query.serverData != undefined &&
      this.$route.query.serverData != null
    ) {
      const serverData: any = this.$route.query.serverData;
      this.serverData = JSON.parse(serverData);
    }
    this.listChange();
    /* if (
      this.$route.query.serverData != undefined &&
      this.$route.query.serverData != null
    ) {
      this.finishedText = "没有更多了";
      const serverData: any = this.$route.query.serverData;
      this.serverData = JSON.parse(serverData);
      this.listChange();
    } else {
      this.finishedText = "请选择区服";
      this.finished = true;
    } */
  }
  public getRefreshList() {
    this.data = [];
    this.page = 1;
    this.status = false;
    this.loading = false;
    this.finished = false;
    this.getList();
  }
  public async listChange() {
    const obj = {
      size: this.size,
      page: this.page,
      box_game_id: this.obj.box_game_id,
      server_id:
        this.serverData.serverid == undefined ? "" : this.serverData.serverid,
      role_config_id: this.orderData.role_config_id,
      coin_config_id: this.orderData.coin_config_id,
      order_time: this.orderData.order_time,
      order_price: this.orderData.order_price,
    };
    const res = await commodityList(obj);
    if (res.code === 200) {
      this.isLoading = false;
    }
    if (res.code === 200 && JSON.stringify(res.data) != "[]") {
      this.data = [...this.data, ...res.data.data];
      this.loading = false;
      if (
        this.size === res.data.data.length &&
        res.data.total > this.data.length
      ) {
        this.status = true;
        this.finished = false;
      } else {
        this.status = false;
        this.finished = true;
        this.finishedText = "没有更多了";
      }
    }
  }
  public onLoad() {
    if (!this.status) {
      return false;
    }
    this.page = this.page + 1;
    this.listChange();
  }
}
